Bingo.HighlightForm = {};

Bingo.HighlightForm.init = (startDateSelector, endDateSelector, startHiddenSelector, maxDays, creditPrice, creditsTexts, lang) => {
    Bingo.HighlightForm.datePickerInit(startDateSelector, endDateSelector, startHiddenSelector, maxDays, lang);
    Bingo.HighlightForm.creditsInit(startDateSelector, endDateSelector, creditPrice, creditsTexts);
};

Bingo.HighlightForm.creditsInit = (startDateSelector, endDateSelector, creditPrice, creditsTexts) => {
    const generateMessage = (days) => {
        let outputText = '';
        const totalPrice = days * creditPrice;
        if (days > 1) {
            outputText += `${days} ${creditsTexts.days} = `;
        } else {
            outputText += `${days} ${creditsTexts.day} = `;
        }

        if (totalPrice > 1) {
            outputText += `${totalPrice} ${creditsTexts.credits}`;
        } else {
            outputText += `${totalPrice} ${creditsTexts.credit}`;
        }

        return outputText;
    };

    const dateDifference = (firstDate, secondDate) => {
        if (firstDate && secondDate) {
            const diffTime = Math.abs(firstDate.getTime() - secondDate.getTime());
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            return diffDays;
        }

        return 1;
    };

    const updateCredits = (priceSelector) => {
        const days = dateDifference($(startDateSelector).data('datetimepicker').getDate(), $(endDateSelector).data('datetimepicker').getDate());
        $(priceSelector).text(generateMessage(days));
    };

    $(endDateSelector).on('changeDate', () => {
        updateCredits('#js-creditPriceId');
    });

    if ($(endDateSelector).val() !== '') {
        updateCredits('#js-creditPriceId');
    }
};

Bingo.HighlightForm.datePickerInit = (startDateSelector, endDateSelector, startHiddenSelector, maxDays, lang) => {
    const copyTime = (fromDate, toDate) => {
        toDate.setMilliseconds(fromDate.getMilliseconds());
        toDate.setSeconds(fromDate.getSeconds());
        toDate.setMinutes(fromDate.getMinutes());
        toDate.setHours(fromDate.getHours());
    };

    const options = {
        language: lang,
        weekStart: 1,
        minView: 'hour',
        format: 'dd.mm.yyyy hh:ii',
        autoclose: true,
        startDate: new Date(),
    };

    const startEl = $(startDateSelector);
    startEl.get(0).type = 'text';

    startEl.datetimepicker(options)
        .on('show', (event) => {
            Nette.validateControl(event.target);
            $(event.target).parents('.js-textField').addClass('-errorPrevented -labelUp');
        })
        .on('hide', (event) => {
            $(event.target).parents('.js-textField').removeClass('-errorPrevented');
        })
        .on('changeDate', (event) => {
            $(event.target).focus();
            Nette.validateControl(event.target);
        });

    if (startEl.attr('value')) {
        startEl.datetimepicker('setValue');
    }

    const startDate = startEl.data('datetimepicker').getDate();

    if (startHiddenSelector) {
        $(startHiddenSelector).val(startDate.toISOString());
    }

    // Min date is start date plus 1 day
    const minEndDate = new Date(startDate);
    minEndDate.setDate(minEndDate.getDate() + 1);

    // Set hours, minutest and seconds same as start date
    copyTime(startDate, minEndDate);

    maxEndDate = new Date(startDate);
    maxEndDate.setDate(maxEndDate.getDate() + maxDays);

    const endEl = $(endDateSelector);

    endEl.get(0).type = 'text';

    options.useCurrent = false;
    options.startDate = minEndDate;
    options.endDate = maxEndDate;
    options.minView = 'month';
    endEl.datetimepicker(options)
        .on('show', (event) => {
            Nette.validateControl(event.target);
            $(event.target).parents('.js-textField').addClass('-errorPrevented -labelUp');
        })
        .on('hide', (event) => {
            $(event.target).parents('.js-textField').removeClass('-errorPrevented');
        })
        .on('changeDate', (event) => {
            $(event.target).focus();
            Nette.validateControl(event.target);
        });

    if (endEl.attr('value')) {
        endEl.datetimepicker('setValue');
    }

    startEl.on('changeDate', (e) => {
        endPicker = endEl.data('datetimepicker');
        newEnd = new Date(e.date);
        newEnd.setDate(newEnd.getDate() + 1);
        endPicker.setStartDate(newEnd);

        if (newEnd > endPicker.getDate()) {
            endPicker.setDate(newEnd);
        }

        endDate = endPicker.getDate();
        copyTime(e.date, endDate);
        endPicker.setDate(endDate);
        startEl.datetimepicker('setValue');
    });

    endEl.on('changeDate', (e) => {
        const newDate = e.date;
        const orgStartDate = startEl.data('datetimepicker').getDate();
        copyTime(orgStartDate, newDate);
        endEl.data('datetimepicker').setDate(newDate);
        endEl.data('datetimepicker').setValue();
    });
};
